import { handleActions } from 'redux-actions';
import * as Actions from '../actions/studentActions';

const app = handleActions({
  [Actions.setStudents]: (state, action) => ({
    ...state,
    students: action.payload,
  }),
  [Actions.setCurrentStudent]: (state, action) => ({
    ...state,
    currentStudent: action.payload,
  }),
}, {
  students: [],
  currentStudent: {},
});

export default app;
